export default __webpack_public_path__ + "static/media/videos.fe415534.png";